module.exports = __webpack_public_path__ + "static/media/avatar_user.5405d77c.png";